<template>
  <div id="page-batches-list">
    <vx-card>
      <div slot="no-body" class="tabs-container px-6 pt-6">
        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner" alignment="center">
          <vs-tab label="Batch Plants" icon-pack="material-icons" icon="spa">
            <div class="tab-text">
              <batch-plants showHeaders :plantStages="['seedling', 'pre_veg', 'veg', 'flower', 'drying', 'dried', 'mother', 'male']" list="plant" />
            </div>
          </vs-tab>
          <vs-tab label="Print Labels" icon-pack="feather" icon="icon-printer">
            <div class="tab-text">
              <print-label />
            </div>
          </vs-tab>

          <!-- change growth phase -->
          <vs-tab label="Change Growth Phase" icon-pack="material-icons" icon="assessment" @click="toggleChangePlantStageModal" />

          <!-- batch weight summary -->
          <vs-tab label="Batch Weight Summary" icon-pack="material-icons" icon="assessment">
            <div class="tab-text">
              <batch-weight-summary />
            </div>
          </vs-tab>
          <vs-tab label="Archive" icon-pack="feather" icon="icon-archive">
            <div class="tab-text">
              <batch-plants :plantStages="['sold', 'destroyed']" list="archived-plant" />
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>

    <!-- change growth phase modal -->
    <change-growth-phase v-if="isChangeGrowthPhaseModalMounted" :isModalShow.sync="isChangeGrowthPhaseModalShow" :batchId="Number($route.params.id)" :plantStages="[]" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import BatchPlants from '@/views/batches/components/BatchPlants.vue'
import BatchWeightSummary from '@/views/batches/components/BatchWeightSummary.vue'
import PlantBulkStageUpdate from '@/views/batches/components/PlantBulkStageUpdate.vue'
import PrintLabel from '@/views/batches/components/PrintLabel.vue'
import ChangeGrowthPhase from '@/views/batches/components/modals/plants/ChangeGrowthPhase'

export default {
  name: 'ViewBatch',

  components: {
    BatchPlants,
    BatchWeightSummary,
    PlantBulkStageUpdate,
    PrintLabel,
    ChangeGrowthPhase
  },

  data: () => ({
    activeTab: 0,

    // change growth phase
    isChangeGrowthPhaseModalMounted: false,
    isChangeGrowthPhaseModalShow: false
  }),

  async mounted() {
    if (this.$route.query.activeTab) {
      setTimeout(() => {
        this.activeTab = this.$route.query.activeTab
      }, 200)
    }

    await this.getBatchById(this.$route.params.id)
  },

  methods: {
    ...mapActions('batch', { getBatchById: 'get' }),

    // change growth phase
    toggleChangePlantStageModal() {
      this.isChangeGrowthPhaseModalMounted = true
      this.isChangeGrowthPhaseModalShow = true
    }
  },

  watch: {
    // handle callback for change growth phase
    isChangeGrowthPhaseModalShow: {
      immediate: true,
      handler(newVal) {
        if (newVal === false) {
          setTimeout(() => {
            this.isChangeGrowthPhaseModalMounted = false
            this.activeTab = 0
            this.selectedBatch = null
          }, 0)
        }
      }
    }
  }
}
</script>
